export const BILL_FORM = 'bill-form'

export const IS_OWNER = '1'
export const IS_NOT_OWNER = '0'
